import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyAdminThemeToDocument, useAdminTheme } from '../../services/adminTheme';

export default function AdminThemeController() {
  const location = useLocation();
  const { preference, resolvedTheme } = useAdminTheme();

  useEffect(() => {
    applyAdminThemeToDocument(location.pathname, preference, resolvedTheme === 'dark');
  }, [location.pathname, preference, resolvedTheme]);

  return null;
}
